module.exports = __webpack_public_path__ + "static/media/home_image.416d3045.png";